import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {TreeNode} from "primeng/api";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";

@Component({
    selector: 'dc-page-search',
    templateUrl: 'dc-page-search.component.html',
    styleUrls: ['dc-page-search.component.scss'],
    standalone: false
})
export class DcPageSearchComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    @Input() selectedNode: TreeNode;

    contentEntries: ObjectIdentifier[];
    showSidebar = true;
    isSidebarOpen = true;
    hierarchyTree: TreeNode[];
    editingContentId: number;



    constructor() {
    }

    ngOnInit(): void {
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    toggleSidebar() {
        this.isSidebarOpen = !this.isSidebarOpen;
    }


    hierarchyTreeEvent($event: TreeNode[]) {
        this.hierarchyTree = $event;
    }

    handleSelectedNodeChange(node: TreeNode) {
        this.selectedNode = node;
    }

    handleNodeContentEntries(contentEntries: ObjectIdentifier[]) {

        this.contentEntries = null;
        this.editingContentId = null;
        this.contentEntries = contentEntries;

    }

    // handleUpdatedContent(event: DcPageContentDisplayModeResponseDto, index: number) {
    //     this.contentEntries.splice(index, 1, event);
    // }

    handleEditorModeChange(mode: 'read' | 'edit', content: ObjectIdentifier) {
        if (mode === 'edit') {
            this.editingContentId = content.objectId;
        } else {
            this.editingContentId = null;
        }
    }


    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }
        this.refreshComponent();
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }


}
